<app-breadcrumb [title]="'Facturación'" [breadcrumb]="'Facturación'"></app-breadcrumb>
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">
            <form [formGroup]="facturacionForm" autocomplete="off">
                <div class="checkout-page">
                    <div class="checkout-form d-flex justify-content-center">
                        <div class="col-md-10">
                            <div class="col-md-12 mb-5" *ngIf="listaDatosFacturacion.length > 0; else noData">
                                <label id="datos">Seleccione los datos para facturar</label>
                                <select formControlName="datos" class="form-control" id="datos"
                                    (change)="changeCdfi()" required>
                                    <option style="text-overflow: ellipsis !important" value="" selected
                                        [disabled]="true">Seleccione</option>
                                    <option *ngFor="let cfdi of listaDatosFacturacion; index as i" [ngValue]="cfdi">
                                        {{i+1}} - RFC: {{cfdi.rfc}}, Nombre: {{cfdi.nombre}}, CP: {{cfdi.cp}}
                                    </option>
                                </select>
                                <span class="text-danger"
                                    *ngIf="(facturacionForm.get('datos').touched) && facturacionForm.get('datos').errors?.required">
                                    Campo requerido
                                </span>
                            </div>
                            <ng-template #noData>
                                <div class="col-md-12 mb-5">
                                    <label id="usoCfdi">Aún no has registrado datos, por favor agrega datos de
                                        facturación para generar la factura</label>
                                    </div>
                            </ng-template>
                            <div class=" d-flex gap-3 justify-content-end" >
                                <button class="btn btn-solid mt-2 " (click)="modalDatosFacturacion()" *ngIf="listaDatosFacturacion.length === 0">Agregar datos</button>
                                <button class="btn btn-solid mt-2 " (click)="facturar()">Generar Factura</button>
                                <button class="btn btn-solid mt-2 " (click)="volver()">Volver</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<div *ngIf="modalSwitch === true">
    <app-modal-facturacion></app-modal-facturacion>
  </div>